// src/locales/ta/attributes.js
export const attributes = {

    // Page titles and descriptions
    title: "தயாரிப்பு பண்புக்கூறுகள்",
    description: "சிறந்த தயாரிப்பு அமைப்புக்கு தயாரிப்பு பண்புக்கூறுகள் மற்றும் அவற்றின் மதிப்புகளை நிர்வகிக்கவும்",
    
    // Navigation
    addAttribute: "பண்புக்கூறு சேர்க்கவும்",
    createNewAttribute: "புதிய பண்புக்கூறு உருவாக்கவும்",
    editAttribute: "பண்புக்கூறு திருத்தவும்",
    createFirstAttribute: "முதல் பண்புக்கூறு உருவாக்கவும்",
    
    // Form Fields
    attributeName: "பண்புக்கூறு பெயர்",
    attributeNamePlaceholder: "பண்புக்கூறு பெயரை உள்ளிடவும் (எ.கா: அளவு, நிறம், பொருள்)",
    values: "மதிப்புகள்",
    valuePlaceholder: "மதிப்பு {{index}} உள்ளிடவும்",
    addValue: "மதிப்பு சேர்க்கவும்",
    removeValue: "மதிப்பு நீக்கவும்",
    valueCount: "மதிப்புகள்",
    
    // Table Headers
    filteredResults: "{{total}} இல் {{count}} பண்புக்கூறுகள்",
    totalAttributes: "{{count}} பண்புக்கூறுகள்",
    searchAttributes: "பெயர் அல்லது மதிப்புகளால் பண்புக்கூறுகளைத் தேடவும்...",
    
    // Validation Messages
    nameRequired: "பண்புக்கூறு பெயர் தேவை",
    nameMinLength: "பண்புக்கூறு பெயர் குறைந்தபட்சம் 2 எழுத்துக்களாக இருக்க வேண்டும்",
    valuesRequired: "குறைந்தபட்சம் ஒரு மதிப்பு தேவை",
    duplicateValues: "நகல் மதிப்புகள் அனுமதிக்கப்படவில்லை",
    
    // Actions
    createAttribute: "பண்புக்கூறு உருவாக்கவும்",
    updateAttribute: "பண்புக்கூறு புதுப்பிக்கவும்",
    
    // Success/Error Messages
    attributeCreatedSuccess: "'{{attributeName}}' பண்புக்கூறு வெற்றிகரமாக உருவாக்கப்பட்டது!",
    attributeUpdatedSuccess: "'{{attributeName}}' பண்புக்கூறு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
    attributeDeletedSuccess: "'{{attributeName}}' பண்புக்கூறு வெற்றிகரமாக நீக்கப்பட்டது.",
    failedToCreate: "பண்புக்கூறு உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    failedToUpdate: "பண்புக்கூறு புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    failedToDelete: "பண்புக்கூறு நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    failedToLoadAttribute: "பண்புக்கூறு விவரங்களை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    
    // Loading states
    loadingAttributes: "பண்புக்கூறுகள் ஏற்றப்படுகின்றன...",
    loadingAttributesDesc: "உங்கள் தயாரிப்பு பண்புக்கூறுகளைப் பெறும் வரை காத்திருக்கவும்.",
    
    // Empty states
    noAttributes: "இன்னும் பண்புக்கூறுகள் இல்லை",
    noAttributesDesc: "குறிப்பிட்ட பண்புகளின்படி உங்கள் தயாரிப்புகளை ஒழுங்கமைக்க உங்கள் முதல் தயாரிப்பு பண்புக்கூறை உருவாக்கவும்.",
    noSearchResults: "பண்புக்கூறுகள் கிடைக்கவில்லை",
    noSearchResultsDesc: "உங்கள் தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும் அல்லது அனைத்து பண்புக்கூறுகளையும் பார்க்க வடிகட்டிகளை அழிக்கவும்.",
    
    // Confirmation dialogs
    confirmDelete: "'{{attributeName}}' பண்புக்கூறை நீக்குவது உறுதியா? இந்த செயலை மாற்ற முடியாது மற்றும் இந்த பண்புக்கூறைப் பயன்படுத்தும் தயாரிப்புகளை பாதிக்கலாம்."
};